export class PeakDays {
  elac: Array<Date> = [];
  select: Array<Date> = [];
  signature: Array<Date> = [];
  none: Array<Date> = [];
}
